module.exports = __webpack_public_path__ + "static/media/design-destroyed.7d5931fe.svg";